<template>
  <div>
    <ValidationProvider v-slot='{ errors, passed, failed }' :rules="{ 'required': true}" slim>
      <div :class="[failed && 'lib__field--error', passed && 'lib__field--valid']" class='lib__field'>
        <div class='lib__tiles lib__tiles--inline'>
          <TileRadio
            v-model='value.accountingType'
            item='compensation'
            :label="$t('prosumerDeclaration.accounting.compensation')"
            group='accountingType'>
            <template v-slot:picture>
              <i class='fas fa-exchange-alt'></i>
            </template>
          </TileRadio>
          <TileRadio
            v-model='value.accountingType'
            item='autoConsumption'
            :label="$t('prosumerDeclaration.accounting.autoConsumption')"
            group='accountingType'>
            <template v-slot:picture>
              <i class='fas fa-sync'></i>
            </template>
          </TileRadio>
        </div>
        <error-message :error='errors[0]'></error-message>
      </div>
    </ValidationProvider>
  </div>
</template>

<script lang='ts'>
import Component from 'vue-class-component'
import { Prop, Vue } from 'vue-property-decorator'
import { AccountingInformation } from '@/models/prosumer-declaration/prosumer-declaration'

@Component({
  name: 'accounting-information-component'
})
export default class AccountingInformationComponent extends Vue {
  @Prop({ type: Object, required: true }) public readonly value!: AccountingInformation
}
</script>
